import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { IllustrationSVG } from 'qbe-components/lib/components/illustration/illustration.types';

@Component({
  selector: 'app-illustration-absolute',
  templateUrl: './illustration-absolute.component.html',
  styleUrls: ['./illustration-absolute.component.scss'],
})
export class IllustrationAbsoluteComponent {
  @ViewChild('ref') ref: ElementRef<HTMLDivElement> | undefined;

  @Input() name!: IllustrationSVG;
  @Input() maxWidth!: number | string;
  @Input() width: number | string | undefined;

  get placeholderWidth(): string {
    const nativeElement = this.ref?.nativeElement;

    if (!nativeElement) {
      return '0px';
    }

    return `${nativeElement.clientWidth}px`;
  }

  get placeholderHeight(): string {
    const nativeElement = this.ref?.nativeElement;

    if (!nativeElement) {
      return '0px';
    }

    return `${nativeElement.clientHeight}px`;
  }

  get styles(): Record<string, string> {
    const css: Record<string, string> = {
      maxWidth: typeof this.maxWidth === 'number' ? `${this.maxWidth}px` : this.maxWidth,
    };

    if (this.width) {
      css['width'] = typeof this.width === 'number' ? `${this.width}px` : this.width;
    }

    return css;
  }
}
